<template>
  <div>
    <b-row>
      <b-col md="1"> </b-col>
      <b-col md="10">
        <b-card md="1" bg-variant="none"> {{ computedDescription }}</b-card>
      </b-col>
      <b-col md="1">
        <data-relocate
          :reassigned="reassigned"
          @relocate="doRelocation"
        ></data-relocate>
      </b-col>
    </b-row>
    <br />
    <b-row>
      <b-col md="1">
      </b-col>
      <b-col md="10">
        <b-card bg-variant="light">
          <div v-if="showPrimarySelection">
            Primary
            <interest-select @selectedItems="setPrimaryId" select_table_heading="Primary Interest Selection"/>
          </div>
          <div v-if="showSecondarySelection">
            Secondary
            <interest-select @selectedItems="setSecondaryId" select_table_heading="Secondary Interest Selection"/>
          </div>
          <div v-if="showTertiarySelection">
            Tertiary
            <interest-select @selectedItems="setTertiaryId" select_table_heading="Tertiary Interest Selection"/>
          </div>
          <div v-if="showProfileSelection">
            <profile-select @selectedItems="setProfileId" select_table_heading="Collection For Profile"/>
          </div>
          <b-form-group
            label-cols-lg="3"
            label="Collection"
            label-size="lg"
            label-class="font-weight-bold pt-0"
            class="mb-0"
          >
            <b-form-group
              label="Theme:"
              label-for="nested-name"
              label-cols-sm="3"
              label-align-sm="right"
            >
              <b-form-input readonly
                id="nested-name"
                v-model="attr_copy.name"
              ></b-form-input>
            </b-form-group>
          </b-form-group>
        </b-card>
      </b-col>
      <b-col md="1">
        <data-operations
          :modified="modified"
          :can_update="canUpdate"
          :can_delete="canDelete"
          :can_help="canHelp"
          @update="doUpdate"
          @undo="doUndo"
          @delete="doDelete"
          @cancel="doCancel"
          @help="doHelp"
        ></data-operations>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { http_v1 } from "@/axios"
import { amsMofifiedAttrs } from "@/utils"
import { deepEqual } from '@/utils'
import { amsSchema } from "@/schema"
import InterestSelect from "./InterestSelect.vue"
import DataRelocate from "./DataRelocate.vue"
import DataOperations from './DataOperations.vue'
import ProfileSelect from './ProfileSelect.vue'

export default {
  components: {
    InterestSelect,
    DataRelocate,
    DataOperations,
    ProfileSelect
  },
  data() {
    return {
      ams_type: "collections",
      ams_api_path: "api/admin/v1/",
      modified: false,
      attr_copy: {},
      attr_orig: {},
      description: undefined,
      reassigned: false,
      primary_interest_name: "",
      secondary_interest_name: "",
      tertiary_interest_name: "",
      profile_id: undefined
    };
  },
  computed: {
    computedDescription() {
      return (
        this.primary_interest_name +
        " & " +
        this.secondary_interest_name +
        " & " +
        this.tertiary_interest_name
      );
    },
    showPrimarySelection() {
      return !this.attr_copy["primary-interest-id"]
    },
    showSecondarySelection() {
      return !this.attr_copy["secondary-interest-id"]
    },
    showTertiarySelection() {
      return !this.attr_copy["tertiary-interest-id"]
    },
    showProfileSelection () {
      return !this.profile_id
    },
    canUpdate() {
      return (
        this.modified &&
        (this.attr_copy["primary-interest-id"]?.length > 0 || this.attr_copy["primary-interest-id"] > 0) &&
        (this.attr_copy["secondary-interest-id"]?.length > 0 || this.attr_copy["secondary-interest-id"] > 0) &&
        (this.attr_copy["secondary-interest-id"]?.length > 0 || this.attr_copy["secondary-interest-id"] > 0) &&
        this.attr_copy["name"]?.length > 0
      )
    },
    canDelete() {
      return false
    },
    canHelp() {
      return true
    }
  },
  methods: {
    doUpdate() {
      this.callApi()
    },
    doUndo() {
        this.attr_copy = Object.assign( {}, this.attr_orig)
    },
    doCancel() {
      this.$router.go(-1)
    },
    doDelete() {
    },
    doHelp() {
      http_v1.get(this.ams_api_path + 'features', {
        params: {
          title: this.ams_type
        }
      }).then(response => {
        if( response.data) {
          let feature = response.data.data[0]
          this.$router.push( {path: '/features' + '/' + feature.id + '/show'} )
        }
      }).catch(error => {
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    setPrimaryId(items) {
      this.attr_copy["primary-interest-id"] = items[0].id;
      this.primary_interest_name = items[0].attributes["name"];
    },
    setSecondaryId(items) {
      this.attr_copy["secondary-interest-id"] = items[0].id;
      this.secondary_interest_name = items[0].attributes["name"];
    },
    setTertiaryId(items) {
      this.attr_copy["tertiary-interest-id"] = items[0].id;
      this.tertiary_interest_name = items[0].attributes["name"];
    },
    setProfileId(items) {
      this.profile_id = items[0].id
      this.attr_copy['name'] = items[0].attributes['unique-alias'] + " NEW"
    },
    doRelocation() {
      this.attr_copy["primary-interest-id"] = null;
      this.attr_copy["secondary-interest-id"] = null;
      this.attr_copy["tertiary-interest-id"] = null;
      this.primary_interest_name = "";
      this.secondary_interest_name = "";
      this.tertiary_interest_name = "";
    },
    apiResourcePath() {
      return this.ams_api_path + this.ams_type.replace(/-/g, "_");
    },
    callApi() {
      let attr_params = amsMofifiedAttrs(this.attr_copy, this.attr_orig);
      attr_params["profile_id"] = this.profile_id
      http_v1
        .post(this.apiResourcePath(), {
          ...attr_params,
        })
        .then(() => {
          this.$router.go(-1);
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            var message =
              error.response.data.message ||
              JSON.stringify(error.response.data);
            if (error.response.status === 500) message = "500 Server Error";
            this.$bvToast.toast(message, {
              title: "Error",
              autoHideDelay: 5000,
              appendToast: true,
            });
          }
        });
    },
  },
  watch: {
     attr_copy : {
        handler() {
          if(deepEqual(this.attr_copy,this.attr_orig)) {
            this.modified = false
          }
          else {
            this.modified = true
          }
        },
        deep: true
     }
  },
  mounted() {
    if (this.ams_template?.attributes) {
      this.attr_copy = { ...this.ams_template.attributes };
    } else {
      const included_obj = amsSchema.find((el) => el.type === this.ams_type);
      this.attr_copy = { ...included_obj.attributes };
    }
    this.description = this.ams_template?.description;
  },
};
</script>